import { shortenFileName } from '@/utils/mediaUtils';
import styles from './MediaItem.module.css';

interface MediaItemPropsFile {
  file: File;
  src?: never;
}

interface MediaItemPropsSrc {
  src: string;
  file?: never;
}

type FileUploaderProps = (MediaItemPropsFile | MediaItemPropsSrc) & {
  sizeSm?: boolean;
  bottomIcon?: () => JSX.Element | undefined;
  topIcon?: () => JSX.Element | undefined;
  opacity?: boolean;
  onClick?: () => void;
};

export function MediaItem({
  file,
  src,
  sizeSm,
  bottomIcon,
  topIcon,
  opacity,
  onClick
}: FileUploaderProps) {
  return (
    <div
      className={`${styles.mediaItem} ${sizeSm ? styles.sm : ''} ${opacity ? styles.opacity : ''}`}
      onClick={onClick}
    >
      {file &&
        (file.type.startsWith('video/') ? (
          <div className={styles.preview}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_4574_6061)">
                <path
                  d="M12 21C12 21.553 11.552 22 11 22H5C2.243 22 0 19.757 0 17V5C0 2.243 2.243 0 5 0H17C19.757 0 22 2.243 22 5V11C22 11.553 21.552 12 21 12C20.448 12 20 11.553 20 11V5C20 3.346 18.654 2 17 2H5C3.346 2 2 3.346 2 5V11.959L4.808 9.151C6.34 7.618 8.833 7.618 10.366 9.151L15.707 14.492C16.098 14.883 16.098 15.515 15.707 15.906C15.512 16.101 15.256 16.199 15 16.199C14.744 16.199 14.488 16.101 14.293 15.906L8.952 10.565C8.2 9.814 6.976 9.813 6.222 10.565L2 14.787V17C2 18.654 3.346 20 5 20H11C11.552 20 12 20.447 12 21ZM15 3.5C16.654 3.5 18 4.846 18 6.5C18 8.154 16.654 9.5 15 9.5C13.346 9.5 12 8.154 12 6.5C12 4.846 13.346 3.5 15 3.5ZM15 5.5C14.449 5.5 14 5.948 14 6.5C14 7.052 14.449 7.5 15 7.5C15.551 7.5 16 7.052 16 6.5C16 5.948 15.551 5.5 15 5.5Z"
                  fill="#474E54"
                  fillOpacity="0.5"
                />
                <path
                  d="M19.9998 18.5858L22.1211 16.4645C22.5114 16.0741 23.1443 16.0734 23.5353 16.4645C23.9263 16.8555 23.9256 17.4884 23.5353 17.8787L21.414 20L23.5353 22.1213C23.9263 22.5123 23.9256 23.1452 23.5353 23.5355C23.145 23.9259 22.5121 23.9266 22.1211 23.5355L19.9998 21.4142L17.8785 23.5355C17.4881 23.9259 16.8553 23.9266 16.4642 23.5355C16.0732 23.1445 16.0739 22.5116 16.4642 22.1213L18.5856 20L16.4642 17.8787C16.0732 17.4876 16.0739 16.8548 16.4642 16.4645C16.8546 16.0741 17.4874 16.0734 17.8785 16.4645L19.9998 18.5858Z"
                  fill="#474E54"
                  fillOpacity="0.5"
                />
              </g>
              <defs>
                <clipPath id="clip0_4574_6061">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span>{shortenFileName(file.name, sizeSm ? 15 : 30)}</span>
          </div>
        ) : (
          <img src={URL.createObjectURL(file)} alt="" />
        ))}
      {src && <img src={src} alt="" />}
      {topIcon && <div className={styles.topIcon}>{topIcon()}</div>}
      {bottomIcon && <div className={styles.bottomIcon}>{bottomIcon()}</div>}
    </div>
  );
}
